import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Observable, map, switchMap } from 'rxjs';
import {
  IconTypes,
  PencilIconComponent,
} from 'src/app/standalones/components/pencil-icon/pencil-icon.component';
import {
  PencilButtonComponent,
  PencilButtonThemeEnum,
} from 'src/app/standalones/components/pencil-button/pencil-button.component';
import { UserService } from '../../services/user.service';
import { PlanDetailsService } from '../../services/plan-details.service';
import { Subscription } from '../../models/payment';

@Component({
  selector: 'app-institution-upgrade-success-modal',
  templateUrl: './institutional-plan-upgrade-success-modal.component.html',
  styleUrls: ['./institutional-plan-upgrade-success-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, TranslateModule, PencilButtonComponent, PencilIconComponent],
})
export class InstitutionalPlanUpgradeSuccessModalComponent {
  PencilButtonThemeEnum = PencilButtonThemeEnum;
  IconTypes = IconTypes;

  readonly data$: Observable<{ institutionName: string; planName: string }>;

  constructor(
    public dialogRef: MatDialogRef<InstitutionalPlanUpgradeSuccessModalComponent>,
    private userService: UserService,
    private planDetailsService: PlanDetailsService,
    private translateService: TranslateService,
  ) {
    this.data$ = this.userService.user.pipe(
      switchMap((userData) => {
        const subscription = userData?.user?.institution?.billingStatus
          ?.subscription as Subscription;
        return this.planDetailsService.getPlanByPlanId(subscription?.plan).pipe(
          map((matchingPlan) => ({
            institutionName: userData?.user?.institution?.name || '',
            planName: matchingPlan?.name || this.translateService.instant('custom plan'),
          })),
        );
      }),
    );
  }

  viewGuide(): void {
    window.open(
      'https://helpdesk.pencilspaces.com/en/collections/17249653-quickstart-guides',
      '_blank',
    );
  }

  close(): void {
    this.dialogRef.close();
  }
}
